{
  "list": {
    "title": "Фильтры",
    "create": "Создать фильтр",
    "import": "Импортировать фильтр",
    "loadError": "Произошла ошибка при загрузке фильтров.",
    "statusAll": "Все",
    "statusEnabled": "Включено",
    "statusDisabled": "Отключено",
    "noStatusFilters": "Нет фильтров со статусом {{status}}",
    "noFilters": "Здесь нет фильтров..",
    "addNew": "Добавить",
    "copied": "Фильтр скопирован в буфер обмена!",
    "copyFailed": "Не удалось скопировать JSON в буфер обмена.",
    "fetchFailed": "Не удалось получить данные фильтра.",
    "deleted": "Фильтр {{name}} был удалён",
    "duplicated": "Фильтр {{name}} дублирован",
    "updated": "{{name}} успешно обновлён",
    "removeTitle": "Удалить фильтр: {{name}}",
    "removeText": "Вы уверены, что хотите удалить этот фильтр? Это действие нельзя отменить.",
    "edit": "Редактировать",
    "exportJson": "Экспортировать JSON",
    "exportJsonDiscord": "Экспортировать JSON в Discord",
    "toggle": "Переключить",
    "duplicate": "Дублировать",
    "delete": "Удалить",
    "toggleSuccess": "{{name}} был успешно {{state}}",
    "enabledState": "включён",
    "disabledState": "отключён",
    "autoUpdatedTitle": "Этот фильтр автоматически обновляется списком",
    "priority": "Приоритет",
    "actions": "Действия",
    "noActionsDefined": "Действия не заданы. Настройте действия, чтобы включить скачивание.",
    "noActionsEnabled": "Нужно включить хотя бы одно действие в фильтре, иначе скачиваний не будет.",
    "downloads": "Загрузки",
    "per": "за",
    "usesDisabledIndexers": "Использует отключённые индексаторы: {{names}}",
    "noIndexer": "НЕТ ИНДЕКСАТОРА",
    "sort": {
      "label": "Сортировка",
      "default": "Сначала новые",
      "nameAsc": "Имя А-Я",
      "nameDesc": "Имя Я-А",
      "priorityDesc": "Приоритет высокий-низкий",
      "priorityAsc": "Приоритет низкий-высокий",
      "createdDesc": "Сначала недавно созданные",
      "createdAsc": "Сначала давно созданные",
      "updatedDesc": "Сначала недавно обновлённые",
      "updatedAsc": "Сначала давно обновлённые"
    },
    "indexerFilter": {
      "label": "Индексатор",
      "all": "Все индексаторы"
    }
  },
  "details": {
    "tabs": {
      "general": "Общие",
      "moviesTv": "Фильмы и ТВ",
      "music": "Музыка",
      "advanced": "Расширенные",
      "external": "Внешние",
      "actions": "Действия",
      "notifications": "Уведомления",
      "new": "НОВОЕ"
    },
    "removeTitle": "Удалить фильтр: {{name}}",
    "removeText": "Вы уверены, что хотите удалить этот фильтр? Это действие нельзя отменить.",
    "delete": "Удалить фильтр",
    "reset": "Сбросить значения формы",
    "resetSuccess": "Все значения фильтра сброшены.",
    "save": "Сохранить",
    "validationError": "Ошибка валидации",
    "validationErrors": "Ошибки валидации",
    "mustSelectClient": "Необходимо выбрать клиент"
  },
  "importer": {
    "title": "Импортировать фильтр (в формате JSON или autodl-irssi)",
    "import": "Импортировать",
    "cancel": "Отмена",
    "jsonImported": "Фильтр '{{name}}' успешно импортирован!",
    "jsonImportFailed": "Не удалось импортировать JSON-данные. Информация записана в консоль.",
    "invalidFormat": "Невозможно импортировать данный фильтр — это не JSON и не формат autodl-irssi.",
    "autodlImportFailed": "Не удалось импортировать фильтр autodl-irssi '{{name}}'. Информация записана в консоль.",
    "autodlImportedOne": "Фильтр '{{name}}' успешно импортирован!",
    "autodlImportedMany": "Все {{count}} фильтров успешно импортированы!",
    "autodlImportedPartial": "{{success}}/{{total}} фильтров успешно импортированы. Подробности смотрите в консоли.",
    "placeholder": "Вставьте сюда данные фильтра (либо в формате JSON autobrr, либо весь ваш конфиг autodl-irssi)",
    "warnings": "Предупреждения импорта"
  },
  "general": {
    "filterName": "Имя фильтра",
    "filterNamePlaceholder": "например, Фильтр 1",
    "announceTypes": "типы анонсов",
    "announceTypesTooltip": "НОВОЕ! Сопоставлять релизы, содержащие любой из выбранных типов анонсов.",
    "indexers": "Индексаторы",
    "rulesTitle": "Правила",
    "rulesSubtitle": "Укажите правила обработки/выбора торрентов.",
    "minSize": "Мин. размер",
    "maxSize": "Макс. размер",
    "sizePlaceholder": "например, 100MiB, 80GB",
    "sizeTooltip": "Поддерживаются единицы измерения MB, MiB, GB и т.д.",
    "delay": "Задержка",
    "delayPlaceholder": "Количество секунд задержки перед выполнением действий",
    "delayTooltip": "Количество секунд ожидания перед выполнением действий.",
    "priority": "Приоритет",
    "priorityPlaceholder": "Большее число = выше приоритет",
    "priorityTooltip": "Фильтры проверяются в порядке приоритета. Большее число = выше приоритет.",
    "maxDownloads": "Макс. загрузок",
    "maxDownloadsPlaceholder": "Принимает любое число (0 = бесконечно)",
    "maxDownloadsTooltip": "Максимальное число загрузок в соответствии с выбранной единицей.",
    "maxDownloadsPer": "Макс. загрузок за",
    "selectUnit": "Выберите единицу",
    "maxDownloadsPerTooltip": "Единица времени для подсчёта максимального числа загрузок на фильтр.",
    "skipDuplicatesProfile": "Профиль пропуска дублей",
    "selectProfile": "Выберите профиль",
    "skipDuplicatesProfileTooltip": "Выберите профиль пропуска дублей.",
    "enabled": "Включено",
    "enabledDescription": "Включить или отключить этот фильтр."
  },
  "actionsSection": {
    "title": "Действия",
    "subtitle": "Добавление в клиенты загрузки или запуск пользовательских команд.",
    "addNew": "Добавить",
    "empty": "Действий пока нет!",
    "deleted": "Действие {{name}} было удалено",
    "removeTitle": "Удалить действие фильтра",
    "removeText": "Вы уверены, что хотите удалить это действие? Это действие нельзя отменить.",
    "actionTitle": "Действие",
    "actionSubtitle": "Укажите клиент загрузки для этого действия и его имя",
    "actionType": "Тип действия",
    "selectType": "Выберите тип",
    "actionTypeTooltip": "Выберите тип действия для этого действия.",
    "name": "Имя",
    "removeAction": "Удалить действие",
    "close": "Закрыть"
  },
  "notificationsSection": {
    "title": "Уведомления фильтра",
    "subtitle": "Настройте, какие уведомления должны отправляться для этого фильтра. Они переопределяют глобальные настройки уведомлений.",
    "addNotification": "Добавить уведомление",
    "empty": "Специальные уведомления для этого фильтра не настроены. Будут использоваться глобальные уведомления.",
    "selectNotification": "Выберите уведомление",
    "muted": "Отключено",
    "eventsCount_one": "{{count}} событие",
    "eventsCount_other": "{{count}} событий",
    "removeTitle": "Удалить уведомление",
    "removeText": "Вы уверены, что хотите удалить это уведомление? Это действие нельзя отменить.",
    "notificationTitle": "Уведомление",
    "notificationSubtitle": "Выберите сервис уведомлений и события для срабатывания",
    "notificationService": "Сервис уведомлений",
    "selectNotificationService": "Выберите уведомление",
    "notificationServiceTooltip": "Выберите сервис уведомлений для этого фильтра.",
    "notificationSettings": "Настройки уведомлений",
    "muteFilter": "Отключить уведомления фильтра",
    "muteFilterDesc": "Отключить все уведомления для этого фильтра. Когда уведомления отключены, для релизов, совпавших с этим фильтром, уведомления отправляться не будут.",
    "mutedInfo": "Уведомления фильтра отключены — это переопределяет все глобальные настройки уведомлений",
    "triggerEvents": "События срабатывания",
    "pushApproved": "Отправка одобрена",
    "pushRejected": "Отправка отклонена",
    "pushError": "Ошибка отправки",
    "pushApprovedDesc": "Отправлять уведомление, когда релиз успешно отправлен клиенту",
    "pushRejectedDesc": "Отправлять уведомление, когда релиз отклонён",
    "pushErrorDesc": "Отправлять уведомление при возникновении ошибки во время обработки",
    "removeNotification": "Удалить уведомление",
    "close": "Закрыть"
  },
  "advanced": {
    "common": {
      "useRegex": "Использовать Regex",
      "regexTooltip1": "Это поле полностью поддерживает regex (синтаксис Golang).",
      "regexTooltip2": "Не забудьте включить Use Regex, если используете что-то кроме * и ?.",
      "regexTooltip3": "Режим: (?i) без учёта регистра"
    },
    "releases": {
      "title": "Названия релизов",
      "subtitle": "Сопоставлять только определённые названия релизов и/или игнорировать другие названия релизов.",
      "match": "Сопоставлять релизы",
      "matchPlaceholder": "например, *some?movie*,*some?show*s01*",
      "except": "Исключить релизы",
      "exceptPlaceholder": "например, *bad?movie*,*bad?show*s03*",
      "alert": "Спросите себя:",
      "matchWarning": "У вас есть веская причина использовать «Сопоставлять релизы» вместо одной из других вкладок?",
      "exceptWarning": "У вас есть веская причина использовать «Исключить релизы» вместо одной из других вкладок?"
    },
    "groups": {
      "title": "Группы",
      "subtitle": "Сопоставлять только определённые группы и/или игнорировать другие группы.",
      "match": "Сопоставлять релиз-группы",
      "matchPlaceholder": "например, group1,group2",
      "matchTooltip": "Список релиз-групп для сопоставления, разделённый запятыми.",
      "except": "Исключить релиз-группы",
      "exceptPlaceholder": "например, badgroup1,badgroup2",
      "exceptTooltip": "Список релиз-групп для игнорирования, разделённый запятыми (имеет приоритет над сопоставлением релизов)."
    },
    "categories": {
      "title": "Категории",
      "subtitle": "Сопоставлять или исключать категории (если они анонсируются)",
      "match": "Сопоставлять категории",
      "matchPlaceholder": "например, *category*,category1",
      "matchTooltip": "Список категорий для сопоставления, разделённый запятыми.",
      "except": "Исключить категории",
      "exceptPlaceholder": "например, *category*",
      "exceptTooltip": "Список категорий для игнорирования, разделённый запятыми (имеет приоритет над сопоставлением релизов)."
    },
    "tags": {
      "title": "Теги",
      "subtitle": "Сопоставлять или исключать теги (если они анонсируются)",
      "match": "Сопоставлять теги",
      "matchPlaceholder": "например, tag1,tag2",
      "matchTooltip": "Список тегов для сопоставления, разделённый запятыми.",
      "matchLogic": "Логика сопоставления",
      "matchLogicDefault": "любое",
      "matchLogicTooltip": "Логика, используемая для сопоставления тегов фильтра.",
      "except": "Исключить теги",
      "exceptPlaceholder": "например, tag1,tag2",
      "exceptTooltip": "Список тегов для игнорирования, разделённый запятыми (имеет приоритет над сопоставлением релизов).",
      "exceptLogic": "Логика исключения",
      "exceptLogicDefault": "любое",
      "exceptLogicTooltip": "Логика, используемая для сопоставления исключаемых тегов."
    },
    "uploaders": {
      "title": "Аплоадеры",
      "subtitle": "Сопоставлять или игнорировать аплоадеров (если они анонсируются)",
      "match": "Сопоставлять аплоадеров",
      "matchPlaceholder": "например, uploader1,uploader2",
      "matchTooltip": "Список аплоадеров для сопоставления, разделённый запятыми.",
      "except": "Исключить аплоадеров",
      "exceptPlaceholder": "например, anonymous1,anonymous2",
      "exceptTooltip": "Список аплоадеров для игнорирования, разделённый запятыми (имеет приоритет над сопоставлением релизов)."
    },
    "language": {
      "title": "Язык",
      "subtitle": "Сопоставлять или игнорировать языки (если они анонсируются)",
      "match": "Сопоставлять язык",
      "except": "Исключить язык"
    },
    "origins": {
      "title": "Происхождение",
      "subtitle": "Сопоставлять Internals, Scene, P2P и т.д. (если они анонсируются)",
      "match": "Сопоставлять происхождение",
      "except": "Исключить происхождение"
    },
    "freeleech": {
      "title": "Freeleech",
      "subtitle": "Сопоставлять по freeleech (если объявлено)",
      "percent": "Процент freeleech",
      "percentPlaceholder": "например, 50,75-100",
      "percentTooltip1": "Freeleech может анонсироваться как бинарное true/false значение или как процент — в зависимости от индексатора. Используйте что-то одно.",
      "percentTooltip2": "Переключатель Freeleech переопределяет это поле, если он включён/true.",
      "percentTooltip3": "Подробности смотрите в нашей документации:",
      "toggle": "Freeleech",
      "toggleDescription": "Нельзя использовать вместе с процентом freeleech. Переопределяет процент freeleech, если включено/true.",
      "toggleTooltip1": "Freeleech может анонсироваться как бинарное true/false значение или как процент — в зависимости от индексатора. Используйте что-то одно.",
      "toggleTooltip2": "Это поле переопределяет процент freeleech, если включено/true.",
      "toggleTooltip3": "Смотрите в документации, кто что использует:"
    },
    "feedSpecific": {
      "title": "Только для RSS/Torznab/Newznab",
      "subtitle": "Эти параметры предназначены только для фидов, таких как RSS, Torznab и Newznab",
      "matchDescription": "Сопоставлять описание",
      "matchDescriptionPlaceholder": "например, *some?movie*,*some?show*s01*",
      "exceptDescription": "Исключить описание",
      "exceptDescriptionPlaceholder": "например, *bad?movie*,*bad?show*s03*",
      "minSeeders": "Мин. сидов",
      "maxSeeders": "Макс. сидов",
      "minLeechers": "Мин. личей",
      "maxLeechers": "Макс. личей",
      "countPlaceholder": "Принимает любое число (0 = бесконечно)",
      "seedersTooltip": "Количество {{type}} в соответствии с выбранной единицей. Только для Torznab"
    },
    "rawReleaseTags": {
      "title": "Сырые теги релиза",
      "subtitlePrefix": "Только для опытных пользователей",
      "subtitleSuffix": "Это сырая строка releaseTags из анонса.",
      "warning": "Они могут быть не тем, чем кажутся. Только для очень опытных пользователей, которые понимают, как всё парсится.",
      "match": "Сопоставлять теги релиза",
      "except": "Исключить теги релиза",
      "placeholder": "например, *mkv*,*foreign*"
    }
  },
  "moviesTv": {
    "title": "Фильмы / Сериалы",
    "placeholder": "например, Movie,Show 1,Show?2",
    "wildcardTooltip": "Можно использовать базовую фильтрацию с подстановочными символами * или заменять одиночные символы через ?",
    "years": "Годы",
    "yearsPlaceholder": "например, 2018,2019-2021",
    "yearsTooltip": "Это поле принимает диапазон лет и/или отдельные годы, разделённые запятыми.",
    "seasonEpisode": {
      "title": "Сезоны, эпизоды и дата",
      "subtitle": "Укажите ограничения по сезону, эпизоду, году, месяцам и дню.",
      "seasons": "Сезоны",
      "seasonsPlaceholder": "например, 1,3,2-6",
      "seasonsTooltip": "Смотрите документацию, если хотите скачивать только сезонные паки:",
      "episodes": "Эпизоды",
      "episodesPlaceholder": "например, 2,4,10-20",
      "episodesTooltip": "Смотрите документацию, если хотите скачивать только отдельные эпизоды:",
      "dailyShows": "Ежедневные шоу",
      "months": "Месяцы",
      "monthsPlaceholder": "например, 4,2-9",
      "monthsTooltip": "Это поле принимает диапазон лет и/или отдельные месяцы, разделённые запятыми.",
      "days": "Дни",
      "daysPlaceholder": "например, 1,15-30",
      "daysTooltip": "Это поле принимает диапазон лет и/или отдельные дни, разделённые запятыми.",
      "smartEpisode": "Умный эпизод",
      "smartEpisodeDescription": "Не сопоставлять эпизоды старше последнего совпавшего."
    },
    "quality": {
      "title": "Качество",
      "subtitle": "Укажите ограничения по разрешению, источнику, кодеку и связанным параметрам.",
      "resolutions": "Разрешения",
      "resolutionsTooltip": "Будут сопоставляться релизы, содержащие любое из выбранных разрешений.",
      "sources": "Источники",
      "sourcesTooltip": "Будут сопоставляться релизы, содержащие любой из выбранных источников.",
      "codecs": "Кодеки",
      "codecsTooltip": "Будут сопоставляться релизы, содержащие любой из выбранных кодеков.",
      "containers": "Контейнеры",
      "containersTooltip": "Будут сопоставляться релизы, содержащие любой из выбранных контейнеров.",
      "matchHdr": "Сопоставлять HDR",
      "matchHdrTooltip": "Будут сопоставляться релизы, содержащие любое из выбранных HDR-обозначений.",
      "exceptHdr": "Исключить HDR",
      "exceptHdrTooltip": "Не будут сопоставляться релизы, содержащие любое из выбранных HDR-обозначений (имеет приоритет над сопоставлением HDR).",
      "matchOther": "Сопоставлять прочее",
      "matchOtherTooltip": "Будут сопоставляться релизы, содержащие любое из выбранных обозначений.",
      "exceptOther": "Исключить прочее",
      "exceptOtherTooltip": "Не будут сопоставляться релизы, содержащие любое из выбранных обозначений из «Прочее» (имеет приоритет над сопоставлением прочего)."
    }
  },
  "music": {
    "artists": "Исполнители",
    "artistsPlaceholder": "например, Artist One",
    "albums": "Альбомы",
    "albumsPlaceholder": "например, That Album",
    "wildcardTooltip": "Можно использовать базовую фильтрацию с подстановочными символами * или заменять одиночные символы через ?",
    "matchRecordLabels": "Сопоставлять лейблы",
    "matchRecordLabelsPlaceholder": "например, Anjunabeats, Armada",
    "matchRecordLabelsTooltip": "Список музыкальных лейблов для сопоставления, разделённый запятыми. Поддерживается только Orpheus и Redacted.",
    "exceptRecordLabels": "Исключить лейблы",
    "exceptRecordLabelsPlaceholder": "например, Anjunadeep, Armind",
    "exceptRecordLabelsTooltip": "Список музыкальных лейблов для игнорирования, разделённый запятыми (имеет приоритет над сопоставлением лейблов). Поддерживается только Orpheus и Redacted.",
    "releaseDetails": {
      "title": "Детали релиза",
      "subtitle": "Тип (Album, Single, EP и т.д.) и год релиза (если анонсируется)",
      "musicType": "Тип музыки",
      "musicTypeTooltip": "Будут сопоставляться только релизы с любым из выбранных типов.",
      "years": "Годы",
      "yearsPlaceholder": "например, 2018,2019-2021",
      "yearsTooltip": "Это поле принимает диапазон лет и/или отдельные годы, разделённые запятыми."
    },
    "quality": {
      "title": "Качество",
      "subtitle": "Формат, источник, лог и т.д.",
      "format": "Формат",
      "formatTooltip": "Будут сопоставляться только релизы с любым из выбранных форматов. Это переопределяется Perfect FLAC.",
      "quality": "Качество",
      "qualityTooltip": "Будут сопоставляться только релизы с любым из выбранных качеств. Это переопределяется Perfect FLAC.",
      "media": "Носитель",
      "mediaTooltip": "Будут сопоставляться только релизы с любым из выбранных источников. Это переопределяется Perfect FLAC.",
      "cue": "Cue",
      "cueDescription": "Должна присутствовать информация CUE",
      "log": "Log",
      "logDescription": "Должна присутствовать информация LOG",
      "logScore": "Оценка лога",
      "logScorePlaceholder": "например, 100",
      "logScoreTooltip": "Оценка лога — от 0 до 100. Это переопределяется Perfect FLAC.",
      "or": "ИЛИ",
      "perfectFlac": "Perfect FLAC",
      "perfectFlacDescription": "Переопределяет все настройки качества, источника, формата и cue/log/оценки лога.",
      "perfectFlacTooltip": "Переопределяет все настройки качества, источника, формата и CUE/LOG/оценки LOG.",
      "perfectFlacHint": "Это то, что вам нужно в 90% случаев (вместо опций выше)."
    }
  },
  "external": {
    "title": "Внешние фильтры",
    "subtitle": "Запускайте внешние скрипты или webhook'и и проверяйте статус как часть фильтрации.",
    "addNew": "Добавить",
    "empty": "Внешних фильтров пока нет!",
    "removeTitle": "Удалить внешний фильтр",
    "removeText": "Вы уверены, что хотите удалить этот внешний фильтр? Это действие нельзя отменить.",
    "sectionTitle": "Внешний фильтр",
    "sectionSubtitle": "Укажите тип фильтра и его имя",
    "type": "Тип",
    "name": "Имя",
    "onError": "При ошибке",
    "selectType": "Выберите тип",
    "typeTooltip": "Выберите тип этого внешнего фильтра.",
    "onErrorTooltip": "Выберите действие при ошибке этого внешнего фильтра.",
    "remove": "Удалить внешний",
    "close": "Закрыть",
    "types": {
      "EXEC": "Выполнение",
      "WEBHOOK": "Webhook"
    },
    "onErrorOptions": {
      "REJECT": "Отклонить",
      "CONTINUE": "Продолжить со следующим"
    },
    "execute": {
      "title": "Выполнение",
      "subtitle": "Укажите исполняемый файл, аргумент и ожидаемый код выхода для запуска в качестве предфильтра",
      "path": "Путь к исполняемому файлу",
      "pathPlaceholder": "Абсолютный путь к исполняемому файлу, например /bin/test",
      "pathTooltip": "Для пользовательских команд укажите полный путь к бинарнику/программе, которую вы хотите запустить. Также можно использовать собственные статические переменные:",
      "args": "Аргументы Exec",
      "argsPlaceholder": "Аргументы, например --test \"{{ .TorrentName }}\"",
      "expectedExitStatus": "Ожидаемый код выхода"
    },
    "request": {
      "title": "Запрос",
      "subtitle": "Укажите конечную точку запроса, заголовки и ожидаемый код ответа",
      "endpoint": "Endpoint",
      "endpointPlaceholder": "Хост, например http://localhost/webhook",
      "endpointTooltip": "URL или IP вашего API. Передавайте параметры, API-токены и т.д.",
      "httpMethod": "HTTP-метод",
      "httpMethodDefault": "Выберите HTTP-метод",
      "httpMethodTooltip": "Выберите HTTP-метод для этого webhook. По умолчанию используется POST",
      "headers": "HTTP-заголовки запроса",
      "headersPlaceholder": "HEADER=custom1,HEADER2=custom2",
      "expectedStatus": "Ожидаемый HTTP-код ответа"
    },
    "retry": {
      "title": "Повтор",
      "subtitle": "Поведение повторных попыток при ошибке запроса",
      "retryStatus": "HTTP-коды для повтора",
      "retryStatusPlaceholder": "Повторять при коде, например 202, 204",
      "retryAttempts": "Максимум повторных попыток",
      "retryDelaySeconds": "Задержка повтора в секундах"
    },
    "payload": {
      "title": "Payload",
      "subtitle": "Укажите ваш JSON payload",
      "data": "Данные (json)",
      "dataPlaceholder": "Данные запроса: { \"key\": \"value\" }"
    }
  },
  "actionComponents": {
    "instance": {
      "title": "Инстанс",
      "subtitle": "Выберите конкретный инстанс, который должен обрабатывать этот фильтр релизов."
    },
    "common": {
      "category": "Категория",
      "categoryPlaceholder": "например, category",
      "categoryTooltip": "Категория должна уже существовать.",
      "savePath": "Путь сохранения",
      "savePathPlaceholder": "например, /full/path/to/download_folder",
      "numberNoLimit": "Принимает любое число (0 = без лимита)",
      "limitsTitle": "Лимиты",
      "limitsSubtitle": "Настройте лимиты скорости/ратио/времени сидирования",
      "limitDownloadKib": "Лимит скорости скачивания (KiB/s)",
      "limitUploadKib": "Лимит скорости отдачи (KiB/s)",
      "limitDownloadKb": "Лимит скорости скачивания (KB/s)",
      "limitUploadKb": "Лимит скорости отдачи (KB/s)",
      "ratioLimit": "Лимит ratio",
      "seedTimeMinutes": "Лимит времени сидирования (минуты)",
      "addPaused": "Добавить на паузе",
      "addPausedDescription": "Добавить торрент в состоянии паузы",
      "skipHashCheck": "Пропустить hash-check",
      "skipHashCheckDescription": "Добавить торрент и пропустить hash-check",
      "announceTitle": "Анонс",
      "announceSubtitle": "Укажите число reannounce (если нужно), удаление после Y неудачных анонсов и т.д.",
      "disableReannounce": "Отключить reannounce",
      "disableReannounceDescription": "Reannounce включён по умолчанию. Отключите, если он не нужен",
      "reannounceInterval": "Интервал reannounce. Выполнять каждые X секунд",
      "reannounceIntervalPlaceholder": "7 — значение по умолчанию и рекомендованное",
      "deleteStalled": "Удалять зависшие",
      "deleteStalledDescription": "Удалять зависшие торренты после Y попыток",
      "reannounceMaxAttempts": "Выполнить reannounce Y раз"
    },
    "test": {
      "alert": "Внимание!",
      "text": "Тестовое действие ничего не делает, кроме проверки работы фильтра. Во время тестирования убедитесь, что страница логов открыта."
    },
    "exec": {
      "title": "Аргументы Exec",
      "subtitle": "Укажите исполняемый файл и его аргументы, которые будут запущены при совпадении фильтра. Используйте абсолютный путь.",
      "path": "Путь к исполняемому файлу",
      "pathPlaceholder": "Путь к программе, например /bin/test",
      "arguments": "Аргументы",
      "argumentsPlaceholder": "Аргументы, например --test"
    },
    "watchFolder": {
      "title": "Аргументы отслеживаемой папки",
      "subtitle": "Укажите, куда autobrr должен сохранять загруженные файлы. Используйте абсолютный путь.",
      "directory": "Отслеживаемая папка",
      "directoryPlaceholder": "Отслеживаемая папка, например /home/user/rwatch"
    },
    "webhook": {
      "title": "Аргументы Webhook",
      "subtitle": "Укажите payload, который будет отправлен на нужный endpoint при совпадении фильтра.",
      "endpoint": "Endpoint",
      "endpointPlaceholder": "Хост, например http://localhost/webhook",
      "endpointTooltip": "URL или IP вашего API. Передавайте параметры, API-токены и т.д.",
      "payload": "Payload (json)",
      "payloadPlaceholder": "Данные запроса: { \"key\": \"value\" }"
    },
    "arr": {
      "overrideClientName": "Переопределить имя клиента загрузки для arr",
      "overrideClientNameTooltip": "Переопределить имя клиента загрузки из раздела Clients. Полезно, если внутри arr у вас несколько клиентов.",
      "overrideClientId": "Переопределить ID клиента загрузки для arr УСТАРЕЛО",
      "overrideClientIdTooltip": "Переопределить ID клиента загрузки из раздела Clients. Полезно, если внутри arr у вас несколько клиентов."
    },
    "qbittorrent": {
      "macrosTooltip": "Это поле может использовать макросы для преобразования/добавления значений из метаданных:",
      "tags": "Теги",
      "tagsPlaceholder": "например, tag1,tag2",
      "savePathPlaceholder": "например, /full/path/to/save_folder",
      "savePathTooltip": "Укажите пользовательский путь сохранения для этого действия. Если используется qBittorrent с категориями, этим займётся Automatic Torrent Management.",
      "downloadPath": "Путь загрузки",
      "downloadPathPlaceholder": "например, /full/path/to/download_folder",
      "downloadPathTooltip": "Укажите пользовательский путь для незавершённых загрузок этого действия. Если используется qBittorrent с категориями, этим займётся Automatic Torrent Management.",
      "rulesTitle": "Правила",
      "rulesSubtitle": "Настройте правила торрент-клиента",
      "ignoreRules": "Игнорировать существующие правила клиента",
      "ignoreRulesDescription": "Игнорировать правила, заданные в Client Settings.",
      "contentLayout": "Структура содержимого",
      "contentLayoutDefault": "Выберите структуру содержимого",
      "priority": "Приоритет",
      "priorityDefault": "Отключено",
      "priorityTooltip": "Очередь торрентов будет автоматически включена, если она отключена. Убедитесь, что в клиенте заданы желаемые лимиты.",
      "firstLastPiece": "Скачивать сначала первые и последние части",
      "firstLastPieceDescription": "Добавить торрент и сначала скачивать первые и последние части"
    },
    "deluge": {
      "label": "Метка",
      "labelPlaceholder": "например, label1 (должна существовать в Deluge)",
      "skipHashCheckTooltip": "Это работает только в Deluge v2."
    },
    "transmission": {
      "label": "Метка торрента",
      "labelPlaceholder": "например, label1"
    },
    "rtorrent": {
      "label": "Метка",
      "labelPlaceholder": "например, label1,label2",
      "renameToPath": "Не добавлять имя торрента к пути",
      "renameDefault": "Нет"
    },
    "porla": {
      "preset": "Пресет",
      "presetPlaceholder": "например, default",
      "presetTooltip": "Имя пресета с учётом регистра, настроенное в Porla.",
      "savePathPlaceholder": "например, /full/path/to/torrent/data"
    }
  },
  "addForm": {
    "title": "Создать фильтр",
    "subtitle": "Добавить новый фильтр.",
    "closePanel": "Закрыть панель",
    "name": "Имя",
    "required": "Обязательно",
    "cancel": "Отмена",
    "create": "Создать",
    "added": "Фильтр {{name}} был добавлен"
  }
}
